import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setSortBy } from '../store/shadow_sort/actions';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown, faArrowUp } from '@fortawesome/pro-solid-svg-icons';

import { columnConfig } from './config';

export const Header = ({ direction, setSortBy, sortBy }) => {
  return (
    <thead>
      <tr>
        {Object.keys(columnConfig).map((key) => {
          const config = columnConfig[key];
          return (
            <th
              className={config.sortable ? 'clickable' : ''}
              key={key}
              onClick={config.sortable ? () => setSortBy(key) : null}
            >
              {columnConfig[key].label}
              {sortBy === key && (
                <FontAwesomeIcon className="ms-2" icon={direction === 'asc' ? faArrowUp : faArrowDown}/>
              )}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

Header.propTypes = {
  direction: PropTypes.string,
  setSortBy: PropTypes.func.isRequired,
  sortBy: PropTypes.string,
};

const mapStateToProps = ({ shadowSort: { sortBy, direction } }) => ({
  sortBy,
  direction,
});

const mapDispatchToProps = {
  setSortBy,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
